export default {
  contentTitle: '内容管理',
  clipboard: '剪切板',
  clipboardMessage: '将“admin”传入复制按钮中',
  richText: '富文本',
  threeTierStructure: '三层结构',
  virtualScroll: '虚拟滚动',
  virtualScroll1: '虚拟滚动列表(10000条)',
  virtualScroll2: '虚拟滚动表格(10000条)',
  watermark: '水印',
  openWatermark: '打开水印',
  hideWatermark: '隐藏水印',
  nestedData: '嵌套数据',
  sensitiveInfo: '注：标题不能含有敏感信息!',
  creator: '创建者',
  updater: '更新者',
  author: '作者',
  companyPageTitle: '公司页面配置',
  companyPageConfigTitle: '页面配置',
  companyPageConfigDesc: '配置页面主标题、副标题、背景图片等页面基础信息。',
  companyIntroCard: '公司简介',
  companyIntroDesc: '配置官网"关于创天激光"页中的公司简介段落，可添加多条简介。',
  companyHeroTitle: '页面主标题',
  companyHeroSubtitle: '页面副标题',
  companyBackgroundImage: '背景图片URL',
  companyLogo: '公司Logo',
  companyLogoExtra: '用于网站导航栏Logo和浏览器标签图标',
  companyRecruitmentIntro: '加入我们-引导文案',
  companyContactEmail: '简历投递邮箱',
  companyContactPhone: '联系电话',
  companySavePageConfigSuccess: '页面配置已暂存（未对接接口）',
  companySaveJoin: '保存加入我们配置',
  companySaveJoinSuccess: '加入我们配置已暂存（未对接接口）',
  companyAddIntro: '新增简介',
  companyEditIntro: '编辑简介',
  companyIntroContent: '简介内容',
  companyHistoryTitle: '发展历程',
  companyHistoryDesc: '维护“发展历程”时间轴数据，暂存于前端状态。',
  companyTimelineYear: '年份/时间',
  companyTimelineEvent: '事件标题',
  companyTimelineContent: '事件描述',
  companyAddHistory: '新增发展历程',
  companyEditHistory: '编辑发展历程',
  companyAdvantageTitle: '企业优势',
  companyAdvDesc: '配置优势亮点文案及图标。',
  companyAdvantageIcon: '图标/表情',
  companyAdvantageName: '优势标题',
  companyAdvantageContent: '优势描述',
  companyAddAdvantage: '新增优势',
  companyEditAdvantage: '编辑优势',
  companyJobsTitle: '加入我们',
  companyJobsDesc: '管理岗位信息，用于“加入我们”模块。',
  companyJobName: '职位名称',
  companyJobLocation: '工作地点',
  companyJobType: '岗位性质',
  companyJobTag: '薪资/标签',
  companyJobDesc: '岗位描述',
  companyAddJob: '新增岗位',
  companyEditJob: '编辑岗位',
  companyPreviewTitle: '配置结果（复制给官网）',
  companyPreviewDesc: '复制 JSON 后粘贴至 eee 官网项目，快速更新展示内容。',
  companyCopySuccess: '配置内容已复制到剪贴板',
  companyCopyFailed: '复制失败，请手动选择文本',
  companyOnlyFrontendTips: '当前仅为前端演示页面，后续可接入后端接口持久化。',
  industryConfigTitle: '应用行业配置',
  industryConfigDesc: '配置各行业的名称、页面信息、行业简介、主要应用和技术优势。可以新增、编辑和删除行业。',
  industryNameConfig: '行业名称配置',
  industryName: '行业名称（中文）',
  industryNameEn: '行业名称（英文）',
  industryAdd: '新增行业',
  industryDelete: '删除行业',
  industryDeleteConfirm: '确定要删除这个行业吗？',
  industryCreateSuccess: '行业创建成功',
  industryDeleteSuccess: '删除成功',
  productCategoryAdd: '新增分类',
  productCategoryDelete: '删除分类',
  productCategoryDeleteConfirm: '确定要删除这个产品分类吗？',
  productCategoryDeleteWarning: '删除后该分类下的所有产品也会被删除，此操作不可恢复！',
  productCategoryCreateSuccess: '产品分类创建成功',
  productCategoryDeleteSuccess: '删除成功',
  industryPageConfig: '页面配置',
  industryContentConfig: '行业内容',
  industryHeroTitle: '页面主标题',
  industryHeroSubtitle: '页面副标题',
  industryBackgroundImage: '背景图片',
  industryDescription: '行业简介',
  industryDescriptionEn: '行业简介（英文）',
  industryApplications: '主要应用',
  industryApplicationsEn: '主要应用（英文）',
  industryApplicationsPlaceholder: '每行输入一个应用场景，例如：\n军工零部件打标和追溯\n武器装备标识和识别',
  industryApplicationsHint: '提示：每行输入一个应用场景，换行分隔',
  industryAdvantages: '技术优势',
  industryAdvantagesEn: '技术优势（英文）',
  industryAdvantagesPlaceholder: '每行输入一个技术优势，例如：\n超高精度，满足军工级标准\n耐高温、耐腐蚀，适应极端环境',
  industryAdvantagesHint: '提示：每行输入一个技术优势，换行分隔',
  industrySaveSuccess: '行业配置已暂存（未对接接口）',
  industryPreviewTitle: '配置结果（复制给官网）',
  industryPreviewDesc: '复制 JSON 后粘贴至 eee 官网项目，快速更新展示内容。',
  industryCopySuccess: '配置内容已复制到剪贴板',
  industryCopyFailed: '复制失败，请手动选择文本',
  industryOnlyFrontendTips: '当前仅为前端演示页面，后续可接入后端接口持久化。',
  // Home 页面
  homeCarouselTitle: '顶部轮播图配置',
  homeCarouselDesc: '配置首页顶部的轮播图图片（仅图片），建议尺寸：1800 x 600px（宽高比 3:1），系统会自动适配不同屏幕尺寸',
  homeAdvantageTitle: '公司优势配置',
  homeAdvantageDesc: '配置公司优势的文字内容和背景图',
  homeProfileTitle: '公司简介配置',
  homeProfileDesc: '配置公司简介的文字和图片',
  homeFooterTitle: '底部页脚配置',
  homeFooterDesc: '配置底部页脚的二维码图片和通联文字内容',
  homeCarouselImages: '轮播图图片',
  homeCarouselImagesRequired: '请至少上传一张轮播图',
  homeUploadImage: '请上传图片',
  homeSelectImage: '选择图片',
  homeSelectProduct: '请选择产品',
  homeClickToJump: '点击跳转',
  homeDelete: '删除',
  homeAddCarousel: '添加轮播图',
  homeTitle: '标题',
  homeSubtitle: '副标题',
  homeDescription: '描述文字',
  homeDescriptionEn: '描述文字（英文）',
  homeBackgroundImage: '背景图',
  homeProfileTitleEn: '简介标题（英文）',
  homeProfileDescription: '简介文字',
  homeProfileDescriptionEn: '简介文字（英文）',
  homeProfileImage: '简介图片',
  homeQrcodeImage: '二维码图片',
  homeCompanyName: '公司名称（中文）',
  homeCompanyNameEn: '公司名称（英文）',
  homeAddressCn: '地址（中文）',
  homeAddressEn: '地址（英文）',
  homePhone: '电话',
  homeEmail: '邮箱',
  homeContacts: '联系人信息',
  homeContactName: '联系人姓名',
  homeContactPhone: '联系电话',
  homeAddContact: '添加联系人',
  homeCopyright: '版权信息',
  homeIcp: 'ICP备案号',
  homeInputTitle: '请输入标题',
  homeInputSubtitle: '请输入副标题',
  homeInputDescription: '请输入描述文字',
  homeInputProfile: '请输入公司简介',
  homeInputCompanyName: '请输入公司名称',
  homeInputCompanyNameEn: '请输入公司英文名称',
  homeInputAddress: '请输入地址',
  homeInputAddressEn: '请输入英文地址',
  homeInputPhone: '请输入电话',
  homeInputEmail: '请输入邮箱',
  homeInputContactName: '请输入联系人姓名',
  homeInputContactPhone: '请输入联系电话',
  homeInputCopyright: '请输入版权信息',
  homeInputIcp: '请输入ICP备案号',
  homeLoadFailed: '加载配置失败',
  homeSaveSuccess: '保存成功',
  homeCheckForm: '请检查表单填写',
  homeSaveFailed: '保存失败',
  // Product 页面
  productConfigTitle: '产品配置',
  productConfigDesc: '管理产品分类和具体产品信息，点击分类名称旁的编辑按钮可配置分类信息',
  productAddProduct: '添加产品',
  productImage: '图片',
  productName: '名称',
  productModel: '型号',
  productModelEn: '型号（英文）',
  productModelEnPlaceholder: '产品型号（英文）',
  productDescription: '描述',
  productSort: '排序',
  productStatus: '状态',
  productEnabled: '启用',
  productDisabled: '禁用',
  productOperate: '操作',
  productEdit: '编辑',
  productDelete: '删除',
  productEmpty: '暂无产品，点击"添加产品"创建',
  productEditCategory: '编辑分类',
  productCategoryName: '分类名称',
  productCategoryNameEn: '英文名称',
  productPageTitle: '页面标题',
  productPageSubtitle: '页面副标题',
  productCategoryDescription: '分类描述',
  productCardImage: '卡片图片',
  productCategoryBackgroundImage: '背景图片',
  productSortOrder: '排序',
  productIsActive: '启用状态',
  productEditProduct: '编辑产品',
  productAddProductModal: '添加产品',
  productCategory: '所属分类',
  productSelectCategory: '请选择分类',
  productModelPlaceholder: '产品型号',
  productNamePlaceholder: '产品名称',
  productNameEnPlaceholder: '产品英文名称',
  productBriefDescription: '产品简介',
  productBriefDescriptionEn: '产品简介（英文）',
  productBriefDescriptionExtra: '显示在列表卡片上',
  productBriefDescriptionPlaceholder: '产品简要描述（列表页显示）',
  productDetailDescription: '详情描述',
  productDetailDescriptionEn: '详情描述（英文）',
  productDetailDescriptionExtra: '显示在产品详情页',
  productDetailDescriptionPlaceholder: '产品详细描述（详情页显示）',
  productCoverImage: '产品封面图',
  productCoverImageExtra: '列表页显示的封面图',
  productFeatures: '产品特点',
  productFeaturesExtra: '每行一个特点',
  productFeaturesPlaceholder: '产品特点/优势，每行一个',
  productFeaturesEn: '产品特点（英文）',
  productFeaturesEnExtra: '每行一个特点（英文）',
  productFeaturesEnPlaceholder: '产品特点/优势（英文），每行一个',
  productApplications: '应用领域',
  productApplicationsExtra: '每行一个应用领域',
  productApplicationsPlaceholder: '应用领域，每行一个',
  productApplicationsEn: '应用领域（英文）',
  productApplicationsEnExtra: '每行一个应用领域（英文）',
  productApplicationsEnPlaceholder: '应用领域（英文），每行一个',
  productSpecs: '规格参数',
  productSpecsExtra: '格式：参数名：参数值，每行一个（支持中文冒号和英文冒号）',
  productSpecsPlaceholder: '如：\n功率：50W\n波长：1064nm\n打标范围：110×110mm',
  productSpecsEn: '规格参数（英文）',
  productSpecsEnExtra: '格式：参数名：参数值，每行一个（英文，支持中文冒号和英文冒号）',
  productSpecsEnPlaceholder: '如：\nPower：50W\nWavelength：1064nm\nMarking Range：110×110mm',
  productLoadFailed: '加载配置失败',
  productCategoryUpdateSuccess: '分类配置更新成功',
  productSaveFailed: '保存失败',
  productUpdateSuccess: '产品更新成功',
  productCreateSuccess: '产品创建成功',
  productDeleteSuccess: '删除成功',
  productDeleteFailed: '删除失败',
  productConfirmDelete: '确认删除',
  productConfirmDeleteContent: '确定要删除"{{name}}"吗？',
  productConfirm: '确认',
  productCancel: '取消',
  productSortHint: '数字越小越靠前',
  productCategoryDescriptionPlaceholder: '分类的简要描述',
  productPageTitlePlaceholder: '分类详情页标题',
  productPageSubtitlePlaceholder: '分类详情页副标题',
  productCategoryNamePlaceholder: '如：打标机',
  productCategoryNameEnPlaceholder: '如：Marking Machine',
  // Contact 页面
  contactPageConfig: '页面配置',
  contactPageConfigDesc: '配置官网"联系我们"页面的标题、副标题和背景图片，前端将实时读取并展示。',
  contactSubmit: '提交',
  contactPageTitle: '页面标题',
  contactPageSubtitle: '页面副标题',
  contactBackgroundImage: '背景图片',
  contactInfoConfig: '联系信息配置',
  contactInfoConfigDesc: '配置公司的联系电话、电子邮箱和公司地址，这些信息将在官网的"联系我们"页面展示。',
  contactPhone: '联系电话',
  contactPhoneTooltip: '可以添加多个联系电话，每个电话可以设置联系人描述',
  contactPhoneNumber: '电话',
  contactPhoneDescription: '联系人/描述',
  contactAddPhone: '添加联系电话',
  contactEmail: '电子邮箱',
  contactEmailTooltip: '可以添加多个电子邮箱，每个邮箱可以设置用途描述',
  contactEmailAddress: '邮箱',
  contactEmailDescription: '用途/描述',
  contactAddEmail: '添加电子邮箱',
  contactAddress: '公司地址',
  contactInputPageTitle: '请输入页面标题',
  contactInputPageSubtitle: '请输入页面副标题',
  contactUploadBackgroundImage: '请上传背景图片',
  contactInputPhone: '请输入联系电话',
  contactInputEmail: '请输入电子邮箱',
  contactInputValidEmail: '请输入有效的电子邮箱地址',
  contactInputAddress: '请输入公司地址',
  contactPhonePlaceholder: '如：400-888-8888',
  contactPhoneDescriptionPlaceholder: '如：客服热线、销售咨询等',
  contactEmailPlaceholder: '如：contact@chuangtian.com',
  contactEmailDescriptionPlaceholder: '如：商务合作、技术支持、售后服务等',
  contactAddressPlaceholder: '如：中国广东省深圳市南山区科技园',
  contactPageTitlePlaceholder: '如：联系我们',
  contactPageSubtitlePlaceholder: '如：Contact Us',
  contactLoadFailed: '加载配置失败',
  contactSaveSuccess: '保存成功',
  contactSaveFailed: '保存失败',
  contactPageConfigSaveSuccess: '页面配置保存成功',
  contactPageConfigSaveFailed: '保存页面配置失败',
  contactConfirmDeletePhone: '确认删除该联系电话？',
  contactConfirmDeleteEmail: '确认删除该电子邮箱？',
};
